<template>
  <BasePopup
    :visible="visible"
    popupClass="feedback-success-popup"
    :showCloseBtn="true"
    closeBtnClass="popup-content-close"
    :maskClosable="true"
    @close="handleClose"
  >
    <!-- 社群按钮区域 -->
    <div class="social-buttons">
      <div
        class="social-button facebook-btn"
        @click="openSocialLink('facebook')"
      ></div>
      <div
        class="social-button discord-btn"
        @click="openSocialLink('discord')"
      ></div>
      <div
        class="social-button baha-btn"
        @click="openSocialLink('baha')"
      ></div>
      <div
        class="social-button youtube-btn"
        @click="openSocialLink('youtube')"
      ></div>
    </div>
  </BasePopup>
</template>

<script setup>
import BasePopup from './BasePopup.vue';

// 定义 props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

// 定义 emits
const emit = defineEmits(["close", "update:visible", "jumpLink"]);

// 关闭弹窗
const handleClose = () => {
  emit("close");
  emit("update:visible", false);
};

// 社群链接处理
const openSocialLink = (platform) => {
  const links = {
    facebook: "https://www.facebook.com/ROWorld.Gravity/",
    discord: "https://discord.gg/zZV3fdHDb7",
    baha: "https://forum.gamer.com.tw/B.php?bsn=83054",
    youtube: "https://www.youtube.com/@RagnarokWorld",
  };

  if (links[platform]) {
    emit("jumpLink", links[platform], platform, "反馈成功弹窗");
  }
};
</script>

<style scoped>
/* 社群按钮样式已在全局样式中定义 */
</style>
